export default __webpack_public_path__ + "static/media/Bulk_Points_Upload_Template.ca7107b3.csv";